import { API_BASE_URL, ACCESS_TOKEN } from '../constants/index.js';
import { textRequest, jsonSuccessFailureRequest, downloadFileRequest } from './APIUtils.js';

export function checkClustererIdentifier(identifier, datasetId) {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  return jsonSuccessFailureRequest({
    url: API_BASE_URL + "/clusterer/exists-identifier?identifier=" + encodeURIComponent(identifier) + "&datasetId=" + datasetId,
    method: 'GET'
  })
}

export function createClusterer(datasetId, name, identifier, onClass, clusterer, clustererPrototypeId, annotatorTags, datasetGroups, parameters) {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  var body = { name, //clusterer,
                     clustererPrototypeId, onClass, annotatorTags }

  if (identifier && identifier != null) {
    body = { ...body, identifier }
  }
  if (parameters && parameters != null) {
    body = { ...body, parameters }
  }
  if (datasetGroups && datasetGroups != null) {
    if (datasetGroups.groups) {
      body = { ...body, datasetGroups:datasetGroups.groups }
    }
    if (datasetGroups.inheritedDatasets) {
      body = { ...body, inheritedDatasets:datasetGroups.inheritedDatasets }
    }
  }

  return jsonSuccessFailureRequest({
    url: API_BASE_URL + "/clusterer/new?datasetId=" + datasetId,
    body: JSON.stringify(body),
    method: 'POST',
  })
}

export function getClusterer(id) {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  return jsonSuccessFailureRequest({
    url: API_BASE_URL + "/clusterer/get/" + id,
    method: 'GET'
  })
}

export function updateClusterer(id, name, identifier, clusterer, clustererPrototypeId, annotatorTags, datasetGroups, parameters) {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  var body = { name, //clusterer,
                     clustererPrototypeId, annotatorTags, }

  if (identifier && identifier != null) {
    body = { ...body, identifier }
  }
  if (parameters && parameters != null) {
    body = { ...body, parameters }
  }
  if (datasetGroups && datasetGroups != null) {
    if (datasetGroups.groups) {
      body = { ...body, datasetGroups:datasetGroups.groups }
    }
    if (datasetGroups.inheritedDatasets) {
      body = { ...body, inheritedDatasets:datasetGroups.inheritedDatasets }
    }
  }

  return jsonSuccessFailureRequest({
    url: API_BASE_URL + "/clusterer/update/" + id,
    body: JSON.stringify(body),
    method: 'POST'
  })
}

export function previewLastClustererExecution(id, shard, nextLine) {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  var x = "";
  if (shard != null && nextLine != null) {
    x = "?shard=" + shard + "&offset=" + nextLine;
  }

  return textRequest({
    url: API_BASE_URL + "/clusterer/preview-last-execution/" + id + x,
    method: 'GET'
  });
}

export function previewPublishedClustererExecution(id, shard, nextLine) {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  var x = "";
  if (shard != null && nextLine != null) {
    x = "?shard=" + shard + "&offset=" + nextLine;
  }

  return textRequest({
    url: API_BASE_URL + "/clusterer/preview-published-execution/" + id + x,
    method: 'GET'
  });
}

export function deleteClusterer(id) {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  return jsonSuccessFailureRequest({
    url: API_BASE_URL + "/clusterer/delete/" + id,
    method: 'DELETE'
  });
}

export function clearClustererExecution(id) {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  return jsonSuccessFailureRequest({
    url: API_BASE_URL + "/clusterer/clear-execution/" + id,
    method: 'POST'
  })
}

export function downloadLastClustererExecution(id) {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  downloadFileRequest({
    url: API_BASE_URL + "/clusterer/download-last-execution/" + id,
    method: 'GET'
  });

}

export function downloadLastClustererClustering(id, fileType) {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  downloadFileRequest({
    url: API_BASE_URL + "/clusterer/download-last-clustering/" + id + "?fileType=" + fileType,
    method: 'GET'
  });

}

export function downloadPublishedClustererExecution(id) {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  downloadFileRequest({
    url: API_BASE_URL + "/clusterer/download-published-execution/" + id,
    method: 'GET'
  });

}

export function getClustererByUser(datasetId) {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  return jsonSuccessFailureRequest({
    url: API_BASE_URL + "/clusterer/get-all-my?datasetId=" + datasetId,
    method: 'GET',
  })
}

export function getClusterers(datasetId) {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  return jsonSuccessFailureRequest({
    url: API_BASE_URL + "/clusterer/get-all?datasetId=" + datasetId,
    method: 'GET',
  })
}

export function previewClustererExecution(id, page) {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  return jsonSuccessFailureRequest({
    url: API_BASE_URL + "/clusterer/preview/" + id
      + "?page=" + page,
    method: 'GET',
  })
}

export function executeClusterer(id) {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  return jsonSuccessFailureRequest({
    url: API_BASE_URL + "/clusterer/execute/" + id,
    method: 'POST',
  })
}

export function stopClusterer(id) {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  return jsonSuccessFailureRequest({
    url: API_BASE_URL + "/clusterer/stop-execution/" + id,
    method: 'POST',
  })
}

export function publishClusterer(id) {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  return jsonSuccessFailureRequest({
    url: API_BASE_URL + "/clusterer/publish/" + id,
    method: 'POST',
  })
}

export function unpublishClusterer(id) {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  return jsonSuccessFailureRequest({
    url: API_BASE_URL + "/clusterer/unpublish/" + id,
    method: 'POST',
  })
}

export function republishClusterer(id) {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  return jsonSuccessFailureRequest({
    url: API_BASE_URL + "/clusterer/republish/" + id,
    method: 'POST',
  })
}

export function changeClustererOrder(id, step) {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  return jsonSuccessFailureRequest({
    url: API_BASE_URL + "/clusterer/change-order/" + id + "?step=" + step,
    method: 'POST'
  })
}
